// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PlanController = function ($scope, $routeParams, Plan, PlanVariantByPlan) {
    $scope.plan = Plan.get({ planId: $routeParams.planId });
    $scope.planVariants = PlanVariantByPlan.query({ planId: $routeParams.planId });
};
PlanController.$inject = ['$scope', '$routeParams', 'Plan', 'PlanVariantByPlan'];
